/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./index.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Inline, Stack } from '@atlaskit/primitives/compiled';
import { Products } from '../../../types';
import { Background } from '../../common/background';
import { TopNav } from '../../common/top-nav';
import { Actions } from './actions';
import { Breadcrumbs } from './breadcrumbs';
import { Content } from './content';
import { FloatingActions } from './floating-actions';
import { SideNav } from './side-nav';
var styles = {
  actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q"
};
export var ConfluenceLightTheme = function ConfluenceLightTheme() {
  return /*#__PURE__*/React.createElement(Background, {
    testId: "testId-confluence-wireframe"
  }, /*#__PURE__*/React.createElement(TopNav, {
    product: Products.CONFLUENCE
  }), /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "stretch",
    grow: "fill"
  }, /*#__PURE__*/React.createElement(SideNav, null), /*#__PURE__*/React.createElement(Stack, {
    grow: "fill",
    alignBlock: "start"
  }, /*#__PURE__*/React.createElement(Inline, {
    xcss: styles.actions,
    alignBlock: "center",
    spread: "space-between"
  }, /*#__PURE__*/React.createElement(Breadcrumbs, null), /*#__PURE__*/React.createElement(Actions, null)), /*#__PURE__*/React.createElement(Inline, {
    alignInline: "center"
  }, /*#__PURE__*/React.createElement(Content, null)))), /*#__PURE__*/React.createElement(FloatingActions, null));
};